import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Icon } from '../../icon/icon';
import { MatDialogRef } from '@angular/material/dialog';
import { FormErrorMessage } from '../../forms/form-error-message/form-error-message';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from 'features/auth/auth.service';
import { AlertService } from 'core/services/alert.service';
import { AutoFocusDirective } from 'shared/directives/auto-focus.directive';
import { fieldsMatchValidator } from 'shared/validators/fields-match-validator';
import { ChangePasswordRequestDTO } from 'features/auth/dtos/change-password-request.dto';

@Component({
  selector: 'app-change-password',
  imports: [
    TranslateModule,
    Icon,
    FormErrorMessage,
    FormsModule,
    ReactiveFormsModule,
    AutoFocusDirective
  ],
  providers: [
    AuthService
  ],
  templateUrl: './change-password.html',
  styleUrl: './change-password.scss',
})
export class ChangePassword {

  form!: FormGroup;
  viewPassword = {
    oldPassword: false,
    newPassword: false,
    confirmPassword: false
  }

  constructor(
    private dialogRef: MatDialogRef<ChangePassword>,
    fb: FormBuilder,
    private authService: AuthService,
    private alertService: AlertService
  ){
    this.form = fb.group(
      {
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
    },
    {
      validators: fieldsMatchValidator('newPassword', 'confirmPassword', 'New password', 'Confirm password')
    }
  )
  }

  toggleViewPassword(field: string){
    (this.viewPassword as any)[field] = !(this.viewPassword as any)[field];
  }

  onClose(){
    this.dialogRef.close();
  }

  onSubmit(){
    if(this.form.valid){
      const body = new ChangePasswordRequestDTO(this.form.value);
      this.authService.changePassword(body).subscribe({
        next: (resp) => {
          const { isSuccess = false, message = ''} = resp;
          if(isSuccess){
            this.alertService.successToaster(message);
            this.onClose();
          }
        }
      })
    }
  }
}
